/* eslint-disable import/prefer-default-export */
import Mola from '@api/mola'
import _get from 'lodash/get'
import types from '../constants'
import { viewAllMovieBg, viewAllMovieBgWebp, viewAllMovieMobileBg, viewAllMovieMobileBgWebp } from '@global/imageUrl'
import { getContentTypeName } from '@source/lib/globalUtil'

const getChild = async (playlist, platformId) => {
  const contentTypeName = getContentTypeName(_get(playlist, 'contentType', 'default'))
  if (contentTypeName === 'banner') {
    const bannerPosition = await Mola.getCampaignPosition(playlist.id)
    const positionName = _get(bannerPosition, 'data.positionName', '')
    const bannerResult = await Mola.getFeatureBanner({ id: positionName, platformId })
    const bannerPlaylist = {
      meta: {
        ...bannerResult.meta,
        id: playlist.id,
        title: playlist.title,
        contentType: playlist.contentType,
        sortOrder: playlist.sortOrder,
      },
      data: [...bannerResult.data],
    }
    return bannerPlaylist
  } else {
    return Mola.getPlaylistChild({ id: playlist.id, platformId }).then(result => {
      const filterVisibility = result.data.filter(dt => {
        return dt.visibility === 1
      })

      result = {
        meta: {
          type: result ? result.meta.type : '',
          status: result.meta.status,
          id: playlist.id,
          title: playlist.title,
          contentType: playlist.contentType,
          sortOrder: playlist.sortOrder,
        },
        data: filterVisibility,
      }
      return result
    })
  }
}

const getHomePlaylist = () => async (dispatch, getState) => {
  const store = getState(),
    platformId = _get(store, 'runtime.platformId', 7)

  dispatch({
    type: types.GET_HOME_PL_LOADING,
    payload: {
      playlists: {
        meta: {
          status: 'loading',
          error: '',
        },
        data: [],
      },
      children: {
        meta: {
          status: 'loading',
          error: '',
        },
        data: [],
      },
    },
  })
  return Mola.getHomePlaylist({ platformId }).then(async result => {
    if (result.meta.status === 'error') {
      dispatch({
        type: types.GET_HOME_PL_ERROR,
        payload: {
          playlists: { ...result },
          children: {
            meta: {
              status: 'no_result',
              error: '',
            },
            data: [],
          },
        },
      })
    } else {
      // const featurePlaylist = { id: 'web-featured', title: 'Featured', sortOrder: 0, visibility: 1 }
      const dataFeature = [...result.data]
      const resultFeature = {
        data: dataFeature.filter(dt => {
          return dt.visibility === 1
        }),
        meta: {
          ...result.meta,
        },
      }

      let allChild = []
      if (resultFeature && resultFeature.data.length > 0) {
        const childRequest = resultFeature.data.map(async playlist => {
          const childPlaylists = await getChild(playlist, platformId)
          allChild.push(childPlaylists)
        })

        Promise.all(childRequest).then(() => {
          allChild = allChild.sort((a, b) => a.meta.sortOrder - b.meta.sortOrder)
          const resultChild = {
            meta: {
              status: allChild.length === resultFeature.data.length ? 'success' : 'error',
            },
            data: allChild,
          }
          dispatch({
            type: types.GET_HOME_PL_SUCCESS,
            payload: {
              playlists: resultFeature,
              children: resultChild,
            },
          })
        })
      } else {
        dispatch({
          type: types.GET_HOME_PL_SUCCESS,
          payload: {
            playlists: {
              meta: {
                status: 'no_result',
                error: '',
              },
              data: [],
            },
            children: {
              meta: {
                status: 'no_result',
                error: '',
              },
              data: [],
            },
          },
        })
      }
    }
  })
}

const getHomeBanner = () => (dispatch, getState) => {
  const id = 'desktop-featured'
  const store = getState(),
    platformId = _get(store, 'runtime.platformId', 7)

  dispatch({
    type: types.GET_HOME_BANNER_LOADING,
    payload: {
      meta: {
        status: 'loading',
        error: '',
      },
      data: [],
    },
  })
  return Mola.getFeatureBanner({ id, platformId }).then(result => {
    if (result.meta.status === 'error') {
      dispatch({
        type: types.GET_HOME_BANNER_ERROR,
        payload: {
          meta: {
            status: 'error',
            error: 'Error: home banner failed',
          },
          data: [],
        },
      })
    } else {
      dispatch({
        type: types.GET_HOME_BANNER_SUCCESS,
        payload: result,
      })
    }
  })
}

const getContinueWatching = () => (dispatch, getState) => {
  const store = getState(),
    token = _get(store, 'user.token', null),
    platformId = _get(store, 'runtime.platformId', 7)

  dispatch({
    type: types.GET_HOME_RESUME_VIDEO_LOADING,
    payload: {
      meta: {
        status: 'loading',
        error: '',
      },
      data: [],
    },
  })

  if (!token) {
    return dispatch({
      type: types.GET_HOME_RESUME_VIDEO_ERROR,
      payload: {
        meta: {
          status: 'error',
          error: 'Error: home resume video failed No user token',
        },
        data: [],
      },
    })
  }
  Mola.getContinueWatching({ token, platformId }).then(result => {
    if (result.meta.status === 'error') {
      dispatch({
        type: types.GET_HOME_RESUME_VIDEO_ERROR,
        payload: {
          meta: {
            status: 'error',
            error: 'Error: home resume video failed',
          },
          data: [],
        },
      })
    } else {
      dispatch({
        type: types.GET_HOME_RESUME_VIDEO_SUCCESS,
        payload: result,
      })
    }
  })
}

const getRecommendationUser = () => (dispatch, getState) => {
  const store = getState(),
    uid = _get(store, 'user.uid', null)
  dispatch({
    type: types.GET_RECOMMENDATION_USER_LOADING,
    payload: {
      meta: {
        status: 'loading',
        error: '',
      },
      data: [],
    },
  })
  if (!uid) {
    return dispatch({
      type: types.GET_RECOMMENDATION_USER_ERROR,
      payload: {
        meta: {
          status: 'error',
          error: 'Error: recommendation user video failed No user uid',
        },
        data: [],
      },
    })
  }
  Mola.getRecommendationUser({ uid }).then(result => {
    if (result.meta.status === 'error') {
      dispatch({
        type: types.GET_RECOMMENDATION_USER_ERROR,
        payload: {
          meta: {
            status: 'error',
            error: 'Error: recommendation user video failed',
          },
          data: [],
        },
      })
    } else {
      dispatch({
        type: types.GET_RECOMMENDATION_USER_SUCCESS,
        payload: result,
      })
    }
  })
}

export default {
  getHomePlaylist,
  getHomeBanner,
  getContinueWatching,
  getRecommendationUser
}
